<div *ngIf="isReactive && isMultiple && !isGroupSelect" class="itb-select-wrapper" [formGroup]="parentForm">
  <mat-form-field [ngClass]="isDisabled && isRequired ? 'field-required-disabled' : ''">
    <mat-label>{{ label }}<span class="label-required">*</span></mat-label>
    <mat-select
      [multiple]="isMultiple"
      [class]="className"
      [(ngModel)]="selectedValues"
      [formControlName]="formFieldName"
      [required]="isRequired"
      (openedChange)="onOpenEvent($event)"
      panelClass="itb-select multiple {{extraPanelClasses}}"
      disableOptionCentering
    >
      <ng-container *ngIf="!isDataInStrings">
          <mat-option *ngIf="hasEmptyValueOption">{{emptyValueOption}}</mat-option>
          <mat-option
            *ngFor="let item of items"
            [value]="item"
            [disabled]="item.isDisabled"
            (onSelectionChange)="changeEvent($event)"
          >
          <itb-icon *ngIf="item.hasIcon" [className]="item.iconClassName" ></itb-icon>{{ item.label }}{{ item.name }}
          </mat-option>
      </ng-container>
      <ng-container *ngIf="isDataInStrings">
        <mat-option *ngIf="hasEmptyValueOption">{{emptyValueOption}}</mat-option>
        <mat-option
          *ngFor="let item of itemsStringArray"
          [value]="item"
          [disabled]="item.isDisabled"
          (onSelectionChange)="changeEvent($event)"
        >
          {{ item }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <itb-info-message *ngIf="hasNoDataMessage" [text]="'No data exists'" [className]="'info-danger'"></itb-info-message>
</div>

<div *ngIf ="isReactive && !isMultiple && !isGroupSelect" class="itb-select-wrapper" [formGroup]="parentForm">
    <mat-form-field [ngClass]="isDisabled && isRequired ? 'field-required-disabled' : ''">
      <mat-label>{{ label }}<span class="label-required">*</span></mat-label>
      <mat-select [compareWith]="compareFunction"
        [formControlName]="formFieldName" [required]="isRequired" panelClass="itb-select select-icon {{extraPanelClasses}}" (openedChange)="onOpenEvent($event)" disableOptionCentering>
        <ng-container *ngIf="!isDataInStrings">
            <mat-option *ngIf="hasEmptyValueOption">{{emptyValueOption}}</mat-option>
            <mat-option *ngFor="let item of items" [value]="item" [disabled]="item.isDisabled"
              (onSelectionChange)="changeEvent($event)">
              <itb-icon *ngIf="item.hasIcon" [className]="item.iconClassName" ></itb-icon>{{ item.label }} {{ item.name }}
            </mat-option>
        </ng-container>
        <ng-container *ngIf="isDataInStrings">
          <mat-option *ngIf="hasEmptyValueOption">{{emptyValueOption}}</mat-option>
          <mat-option *ngFor="let item of itemsStringArray" [value]="item" [disabled]="item.isDisabled"
            (onSelectionChange)="changeEvent($event)">
            {{ item }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <itb-info-message *ngIf="hasNoDataMessage" [text]="'No data exists'" [className]="'info-danger'"></itb-info-message>
  </div>
  
<div *ngIf="!isReactive && !isMultiple && !isGroupSelect && !isSelectWithObjects" class="itb-select-wrapper">
  <mat-form-field [ngClass]="isDisabled && isRequired ? 'field-required-disabled' : ''">
    <mat-label>{{ label }}<span class="label-required">*</span></mat-label>
    <mat-select
      [(ngModel)]="selected"
      [disabled]="isDisabled"
      (selectionChange)="onSimpleChange($event)"
      [required]="isRequired"
      (openedChange)="onOpenEvent($event)"
      panelClass="itb-select {{extraPanelClasses}}"
      disableOptionCentering
    >
      <mat-option *ngIf="hasEmptyValueOption">{{emptyValueOption}}</mat-option>
      <mat-option *ngFor="let item of itemsStringArray" [value]="item">{{
        item
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <itb-info-message *ngIf="hasNoDataMessage" [text]="'No data exists'" [className]="'info-danger'"></itb-info-message>
</div>

<div *ngIf="!isReactive && isMultiple && !isGroupSelect && !isSelectWithObjects" class="itb-select-wrapper">
    <mat-form-field [ngClass]="isDisabled && isRequired ? 'field-required-disabled' : ''">
      <mat-label>{{ label }}<span class="label-required">*</span></mat-label>
      <mat-select
        [(ngModel)]="selected"
        [disabled]="isDisabled"
        [required]="isRequired"
        multiple
        (selectionChange)="onSimpleChange($event)"
        (openedChange)="onOpenEvent($event)"
        panelClass="itb-select multiple {{extraPanelClasses}}"
        disableOptionCentering
      >
        <mat-option *ngIf="hasEmptyValueOption">{{emptyValueOption}}</mat-option>
        <mat-option *ngFor="let item of itemsStringArray" [value]="item.id">{{
          item.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <itb-info-message *ngIf="hasNoDataMessage" [text]="'No data exists'" [className]="'info-danger'"></itb-info-message>
  </div>

<div *ngIf="isGroupSelect">
  <mat-form-field [ngClass]="isDisabled && isRequired ? 'field-required-disabled' : ''">
    <mat-label> {{label}} <span class="label-required">*</span></mat-label>
      <mat-select [(ngModel)]="selectedValues" [required]="isRequired" (openedChange)="onOpenEvent($event)" panelClass="itb-select {{extraPanelClasses}}" disableOptionCentering>
        <mat-optgroup *ngFor="let option of groupOptions" label="{{option.label}}">
          <mat-option *ngFor="let item of option.options" [value]="item.value" (click)="onGroupSelectChange(option.label, item)">{{item.value}}</mat-option>
        </mat-optgroup>
      </mat-select>
  </mat-form-field>
  <itb-info-message *ngIf="hasNoDataMessage" [text]="'No data exists'" [className]="'info-danger'"></itb-info-message>
</div>

<div *ngIf ="!isReactive && isSelectWithObjects" class="itb-select-wrapper">
  <mat-form-field [ngClass]="isDisabled && isRequired ? 'field-required-disabled' : ''">
    <mat-label>{{ label }}<span class="label-required">*</span></mat-label>
    <mat-select [(ngModel)]="selectedValues" [compareWith]="compareFunction" [multiple]="isMultiple" [disabled]="isDisabled" [required]="isRequired" (openedChange)="onOpenEvent($event)"
     panelClass="itb-select select-icon {{extraPanelClasses}}" disableOptionCentering>
        <mat-option *ngIf="hasEmptyValueOption">{{emptyValueOption}}</mat-option>
        <mat-option *ngFor="let item of items" [value]="item" [disabled]="item.isDisabled"
          (onSelectionChange)="changeEvent($event)">
          <itb-icon *ngIf="item.hasIcon" [className]="item.iconClassName" ></itb-icon>{{ item.label }} {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <itb-info-message *ngIf="hasNoDataMessage" [text]="'No data exists'" [className]="'info-danger'"></itb-info-message>
</div>
